import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.customerOrderPage.setFetching(isFetching)

const fetchOrder = (orderId) => {
  // const { marketplace: { layersNavigation: { tool } } } = getState()

  const isEdu   = /^edu/.test(orderId)
  const isSport = /^sport/.test(orderId)

  const url = isEdu ? constants.edu.orderData : constants.marketplace.bookingOrder

  return request.get(url + `/${orderId}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.customerOrderPage.setOrder(data))
    .catch((error) => console.log(error))
}


export default {
  setFetching,
  fetchOrder,
}
